module.exports = __webpack_public_path__ + "img/local-hotel-img.31689869.png";